/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export enum RecordingOverlayOptionType {
    CANCEL,
    CANCEL_RECORDING,
    KEEP_UNTIL,
    NO_CHANGE_IN_RECORDING_OPTION,
    SCHEDULE_RECORDING,
    START_RECORDING,
    STOP_AND_DELETE_RECORDING,
    STOP_RECORDING,
    TIME_AND_CHANNEL,
}
